export default "__VITE_ASSET__B55AA716__"